<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10ToVPk/tc-custom/9781466843578.jpg?1737767949279" alt="This image is the cover for the book Cure Unknown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cure Unknown
      </h1>
      <p class="bookDescription body article font2">
        <b>This history of Lyme disease is “a tale of biological complexities, scientific turf battles, political intrigue, human egos, and money—lots of it” (<i>Sacramento Bee</i>).</b><br/><br/><b>Winner, American Medical Writers Association Book Award</b><br/><br/>When Pamela Weintraub, a science journalist, learned that her oldest son tested positive for Lyme disease, she thought she had found an answer to the symptoms that had been plaguing her family for years—but her nightmare had just begun. Almost everything about Lyme disease turned out to be deeply controversial, from the microbe causing the infection to the length and type of treatment and the kind of practitioner needed.<br/><br/>On one side of the fight, the scientists who first studied Lyme describe a disease transmitted by a deer tick that is hard to catch but easy to cure no matter how advanced the case. On the other side, rebel doctors insist that Lyme and a soup of “co-infections” cause a complicated spectrum of illness often dramatically different—and far more difficult to treat—than the original researchers claim. Instead of just swollen knees and a rash, patients can experience exhaustion, disabling pain, and a “Lyme fog” that leaves them dazed and confused. As patients struggle for answers, once-treatable infections become chronic.<br/><br/>In this nuanced picture of the intense controversy and crippling uncertainty surrounding Lyme disease, Pamela Weintraub sheds light on one of the angriest medical disputes raging today. The most comprehensive book ever written about the past, present, and future of Lyme disease, <i>Cure Unknown</i> exposes the ticking clock of a raging epidemic and the vulnerability we all share.<br/><br/><i>Revised with a new chapter</i><br/><br/>“A thoroughly researched and well-written account of the disease’s controversial history.” —Jane Brody, <i>The New York Times</i><br/><br/>“A comprehensive and compassionate guide to a dreaded illness named after a bucolic, tick-infested town on Long Island Sound.” —<i>Hartford Courant</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pamela Weintraub, Hillary Johnson
      </h2>
      
      <p class="authorDescription body article"><P>Pamela Weintraub has written eight other books including YOU CAN SAVE THE ANIMALS: FIFTY THINGS TO DO RIGHT NOW.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?76e1e964